(function(window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var View = APP.module('View');

	View.NotificationBanner = Marionette.ItemView.extend({
		tagName: 'div',
		template: JST.NotificationBanner,
		className: 'notification-banner',
		ui: {
			toggle: '.js-toggle',
			item: '.js-toggle-item',
			close: '.js-close',
			open: '.js-open'
		},
		events: {
			'click @ui.toggle': 'toggle',
			'click @ui.close': 'toggle'
		},
		setDefaultModel: function() {
			this.model.set({
				text: '',
				show: 0
			})
		},
		initialize: function() {
			this.model.fetch().then((res) => {
				this.update();
			})
		},

		update() {
			if (this.model.get('show')===1) {
				this.model.set({ closed: false });
				this.$el.removeClass('hidden');
			}
			if (!this.isDestroyed) {
				this.render();
			}

		},
		toggle() {
			this.ui.item.slideToggle('fast', () => {
				this.ui.open.toggleClass('hidden');
				this.ui.close.toggleClass('hidden');
				this.ui.toggleClass('hidden');
			});
		}
	})

}(window, APP, Backbone, Marionette, $, _));